import {type Palette} from '@bsky.app/alf'

/**
 * X / OpenTwitter-inspired dark palettes for ALF.
 * Tuned to match the reference app’s black canvas, #2f3336 borders, and #1d9bf0 accent.
 */
export function buildOpenTwitterDarkPalette(base: Palette): Palette {
  return {
    ...base,
    white: '#ffffff',
    black: '#000000',
    like: '#f91880',
    contrast_0: '#000000',
    contrast_25: '#080808',
    contrast_50: '#16181c',
    contrast_100: '#1c1f23',
    contrast_200: '#2f3336',
    contrast_300: '#3d4144',
    contrast_400: '#71767b',
    contrast_500: '#8b98a5',
    contrast_600: '#a0a8b0',
    contrast_700: '#bdc3c9',
    contrast_800: '#d4d8dc',
    contrast_900: '#e7e9ea',
    contrast_950: '#eff3f4',
    contrast_975: '#f7f9fa',
    contrast_1000: '#ffffff',
    primary_25: '#061f2a',
    primary_50: '#0a2840',
    primary_100: '#0d3a52',
    primary_200: '#0f4a6b',
    primary_300: '#1a8cd8',
    primary_400: '#47b5f5',
    primary_500: '#1d9bf0',
    primary_600: '#1a8cd8',
    primary_700: '#1781c1',
    primary_800: '#146ba3',
    primary_900: '#1e4f6b',
    primary_950: '#0f3a52',
    primary_975: '#0a2a3d',
  }
}

/** Slightly softer than pure black — closer to “dim” clients without losing the X look. */
export function buildOpenTwitterDimPalette(base: Palette): Palette {
  const tw = buildOpenTwitterDarkPalette(base)
  return {
    ...tw,
    contrast_0: '#000000',
    contrast_25: '#0a0a0a',
    contrast_50: '#121416',
    contrast_100: '#181a1d',
  }
}
